import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareFacebook, faSquareInstagram, faLinktree, faDiscord } from '@fortawesome/free-brands-svg-icons';
import { faLink } from '@fortawesome/free-solid-svg-icons';

function LeagueSocial(props) {
    const fs = (props.size == 'small' ? '20px' : '30px');

    if (!props.social) {
        return (<span>Not Available</span>);
    }
    
    if (props.social.includes('facebook')) {
        return (<Link to={props.social}><FontAwesomeIcon icon={faSquareFacebook} style={{ fontSize: fs }}/></Link>)
    }

    if (props.social.includes('instagram')) {
        return (<Link to={props.social}><FontAwesomeIcon icon={faSquareInstagram} style={{ fontSize: fs, color: '#C13584'}}/></Link>)
    }

    if (props.social.includes('linktr.ee')) {
        return (<Link to={props.social}><FontAwesomeIcon icon={faLinktree} style={{ fontSize: fs, color: '#d2e823'}}/></Link>)
    }

    if (props.social.includes('discord.gg')) {
        return (<Link to={props.social}><FontAwesomeIcon icon={faDiscord} style={{ fontSize: fs, color: '#7289DA'}}/></Link>)
    }

    return (<Link to={props.social}><FontAwesomeIcon icon={faLink} style={{ fontSize: fs }}/></Link>);
}

export default LeagueSocial;
